module.exports = __webpack_public_path__ + "static/media/left_circle.3aa22cd3.svg";